export class Contact {
    name:string;
    phone:string;
    email:string;

    constructor(other ?:Contact) {
        if (other) {
            this.name = other.name;
            this.phone = other.phone;
            this.email = other.email;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/contact.ts
 **/